import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { ModifyArea } from "./Styles";

export default function ModifyDate({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Modificación"
            value={!value ? document.updatedDate.parsed : value}
          />
        </div>
      ) : (
        <ModifyArea>
          <Informative
            readonly={true}
            label="Modificación"
            value={!value ? document.updatedDate.parsed : value}
          />
        </ModifyArea>
      )}
    </>
  );
}
